import { EventActions, EventCategories, EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
var trackOnFilterChange = function(trackEvent) {
    return function(name, filterSection) {
        if (name === "") {
            name = "All ".concat(filterSection, "s");
        }
        var data = {
            event: {
                name: EventNames.click,
                category: EventCategories.button,
                action: EventActions.filter,
                label: name,
                section: filterSection
            }
        };
        trackEvent({
            eventName: "Car reviews hub - filter ".concat(filterSection),
            data: data,
            type: TrackingEventTypes.ADOBE
        });
    };
};
var trackOnReviewCardClick = function(trackEvent) {
    return function(reviewTitle) {
        var data = {
            event: {
                name: EventNames.click,
                category: EventCategories.button,
                action: EventActions.navigate,
                label: reviewTitle
            }
        };
        trackEvent({
            eventName: "Car reviews hub - click review card",
            data: data,
            type: TrackingEventTypes.ADOBE
        });
    };
};
var trackNoResultsFound = function(trackEvent) {
    return function(name) {
        var data = {
            event: {
                name: EventNames.impression,
                category: EventCategories.reviews,
                action: EventActions.noReviewsFound,
                label: name
            }
        };
        trackEvent({
            eventName: "Car reviews hub - No car reviews found",
            data: data,
            type: TrackingEventTypes.ADOBE
        });
    };
};
export var useCarReviewsHubTracking = function() {
    return useAnalytics(function(param) {
        var trackEvent = param.trackEvent;
        return {
            trackOnFilterChange: trackOnFilterChange(trackEvent),
            trackOnReviewCardClick: trackOnReviewCardClick(trackEvent),
            trackNoResultsFound: trackNoResultsFound(trackEvent)
        };
    });
};
